/**
 * These match the permissions we have defined in permissions.py.
 * TODO(@dzhao): Replace with GQL enum for consistency.
 */
export enum Permission {
    ReadUserBasic = "read:user:basic",
    ReadUserRestricted = "read:user:restricted",
    WriteUserOrg = "write:user:org",

    ReadAccountsBasic = "read:accounts:basic",
    ReadAccountsRestricted = "read:accounts:restricted",
    WriteAccounts = "write:accounts",

    ReadCardSelf = "read:cards:self",
    ReadCardOrg = "read:cards:org",
    WriteCardSelf = "write:cards:self",
    WriteCardOrg = "write:cards:org",

    WriteCheckDepositCreate = "write:check_deposit:create",
    WriteTransferInternal = "write:internal_transfer", // Internal transfers and conversions.

    WriteOrgAdmin = "write:org_admin", // Org administrator.
    ReadOrgBasic = "read:org:basic",
    ReadOrgRestricted = "read:org:restricted",

    // We do not support requesting conversions, so avoid using this.
    WriteConversionRequest = "write:conversion:request",
    WriteConversionResolve = "write:conversion:resolve",
    WriteConversionSelfApprove = "write:conversion:self_approve",
    WritePaymentRequest = "write:payment:request",
    // Can assume that users with bulk request perms also have payment request perms.
    WritePaymentBulkRequest = "write:payment:bulk_request",
    WritePaymentResolve = "write:payment:resolve",
    WritePaymentSelfApprove = "write:payment:self_approve",
    WritePaymentAdminOverride = "write:payment:admin_override",
    // ACH debit.
    WritePaymentDebit = "write:payment:debit",
    ReadRecipientOrg = "read:beneficiary:org",
    ReadRecipientSensitiveDetailsOrg = "read:beneficiary:sensitive_details:org",
    ReadRecipientSelf = "read:beneficiary:self",
    RequestRecipientOrg = "request:beneficiary:org",
    // Can assume that users with bulk request perms also have recipient request perms.
    WriteRecipientBulkRequest = "request:beneficiary:bulk",
    WriteRecipientApprove = "write:beneficiary:approve",
    WriteRecipientSelfApprove = "write:beneficiary:self_approve",
    WriteRecipientDisable = "write:beneficiary:disable",
    UpdateBeneficiaryOrg = "update:beneficiary:org",
    UpdateBeneficiarySelf = "update:beneficiary:self",
    UpdateBeneficiaryAccountInfoOrg = "update:beneficiary:account_info:org",
    UpdateBeneficiaryAccountInfoSelf = "update:beneficiary:account_info:self",

    ReadTransactionsSelf = "read:transactions:self", // Transactions on user's card or requested by the user.
    ReadTransactionsOrg = "read:transactions:org",
    ReadActivitiesSelf = "read:activities:self", // Activities requested by the user.
    ReadActivitiesOrg = "read:activities:org",

    ReadBillsSelf = "read:bills:self",
    ReadBillsOrg = "read:bills:org",
    WriteBillsSelf = "write:bills:self",
    WriteBillsOrg = "write:bills:org",

    ReadPayers = "read:payers",
    ReadInvoices = "read:invoices",
    WritePayers = "write:payers",
    WriteInvoices = "write:invoices",

    ReadCommentsOrg = "read:comments:org",
    WriteCommentsSelf = "write:comments:self",

    ReadApprovalRulesOrg = "read:approval_rules:org",

    // API
    ManageApi = "manage:api_key",

    ReadPreferencesOrg = "read:preference:org",
    WritePreferencesOrg = "write:preference:org",
    ReadRecipientAccount = "read:recipient:account",

    // Contracts
    ReadContractsOrg = "read:contracts:org",
    WriteContractsOrg = "write:contracts:org",
    ReadContractsSelf = "read:contracts:self",
    WriteContractsSelf = "write:contracts:self",
    RequestContracts = "write:contracts:request",
}
